import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=120bb7b4"
import script from "./ContextMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ContextMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ContextMenu.vue?vue&type=style&index=0&id=120bb7b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports